"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readAmount = exports.writeAmount = exports.getSizeOfAmount = exports.readVarInt = exports.writeVarInt = exports.getSizeOfVarInt = exports.writeStringNoLength = exports.readStringNoLength = exports.getSizeOfStringNoLength = exports.readString = exports.writeString = exports.getSizeOfString = void 0;
var buffer_1 = require("buffer");
var BigInteger = require("bigi");
var TEN = BigInteger.valueOf(10);
var ZERO = BigInteger.valueOf(0);
function getSizeOfString(value) {
    return getSizeOfVarInt(value.length) + value.length;
}
exports.getSizeOfString = getSizeOfString;
function writeString(value, buffer, offset) {
    offset = writeVarInt(value.length, buffer, offset);
    buffer.write(value, offset);
    return offset + value.length;
}
exports.writeString = writeString;
function readString(buffer, offset) {
    var _a = readVarInt(buffer, offset), length = _a.value, offset2 = _a.offset;
    var value = buffer.toString('utf8', offset2, offset2 + length);
    return { value: value, offset: offset2 + length };
}
exports.readString = readString;
function getSizeOfStringNoLength(value) {
    return value.length;
}
exports.getSizeOfStringNoLength = getSizeOfStringNoLength;
function readStringNoLength(buffer, offset, length) {
    var value = buffer.toString('utf8', offset, offset + length);
    return { value: value, offset: offset + length };
}
exports.readStringNoLength = readStringNoLength;
function writeStringNoLength(value, buffer, offset) {
    buffer.write(value, offset);
    return offset;
}
exports.writeStringNoLength = writeStringNoLength;
function getSizeOfVarInt(value) {
    var size = 0;
    while (true) {
        size++;
        if (value <= 0x7F)
            break;
        value = (value >> 7) - 1;
    }
    return size;
}
exports.getSizeOfVarInt = getSizeOfVarInt;
function writeVarInt(value, buffer, offset) {
    var tmp = new Uint8Array(5);
    var len = 0;
    while (true) {
        tmp[len] = (value & 0x7F) | (len !== 0 ? 0x80 : 0x00);
        if (value <= 0x7F)
            break;
        value = (value >> 7) - 1;
        len++;
    }
    tmp = tmp.slice(0, len + 1);
    tmp.reverse();
    buffer_1.Buffer.from(tmp).copy(buffer, offset);
    return offset + len + 1;
}
exports.writeVarInt = writeVarInt;
function readVarInt(buffer, offset) {
    var value = 0;
    while (true) {
        var chData = buffer.readUInt8(offset);
        offset++;
        value = (value << 7) | (chData & 0x7F);
        if ((chData & 0x80) !== 0)
            value++;
        else
            return { value: value, offset: offset };
    }
}
exports.readVarInt = readVarInt;
function factor(x) {
    function inner(s, e) {
        if (!s.mod(TEN).equals(ZERO))
            return [s, e];
        else
            return inner(s.divide(TEN), e + 1);
    }
    return inner(x, 0);
}
function figures(s) {
    function inner(s, f) {
        if (s.equals(ZERO))
            return f;
        else
            return inner(s.divide(TEN), f + 1);
    }
    return inner(s, 0);
}
function parse(x) {
    if (x.equals(ZERO))
        return [ZERO, 0, 0];
    else {
        var _a = factor(x), s = _a[0], e = _a[1];
        var f = figures(s);
        return [s, e, f];
    }
}
function write16(buffer, offset, s, e) {
    var res = s.or(BigInteger.valueOf(e << 10)).intValue();
    buffer.writeUInt16BE(res, offset);
    return offset + 2;
}
var cutoff = BigInteger.valueOf(0x04000000);
function write32(buffer, offset, s, e) {
    if (s.compareTo(cutoff) < 0) {
        var shifted = BigInteger.valueOf(0x20 | e).shiftLeft(26);
        var res = s.or(shifted);
        res.toBuffer(4).copy(buffer, offset);
    }
    else {
        var shifted = BigInteger.valueOf(0x60 | e).shiftLeft(25);
        var res = s.subtract(cutoff).or(shifted);
        res.toBuffer(4).copy(buffer, offset);
    }
    return offset + 4;
}
function write64(buffer, offset, s) {
    var res = BigInteger.valueOf(0x7E).shiftLeft(56).or(s);
    res.toBuffer(8).copy(buffer, offset);
    return offset + 8;
}
function write72(buffer, offset, s) {
    offset = buffer.writeUInt8(0xFE, offset);
    s.toBuffer(8).copy(buffer, offset);
    return offset + 8;
}
var maximum64bit = BigInteger.valueOf(2).pow(BigInteger.valueOf(56));
function getSizeOfAmount(amount) {
    var _a = parse(amount), s = _a[0], e = _a[1], f = _a[2];
    if (f <= 3) {
        return 2;
    }
    else if (f <= 8) {
        return 4;
    }
    else if (amount.compareTo(maximum64bit) < 0) {
        return 8;
    }
    else {
        return 9;
    }
}
exports.getSizeOfAmount = getSizeOfAmount;
function writeAmount(amount, buffer, offset) {
    var _a = parse(amount), s = _a[0], e = _a[1], f = _a[2];
    if (f <= 3) {
        return write16(buffer, offset, s, e);
    }
    else if (f <= 8) {
        if (e <= 12) {
            return write32(buffer, offset, s, e);
        }
        else {
            var m = TEN.pow(BigInteger.valueOf(e - 12));
            return write32(buffer, offset, s.multiply(m), 12);
        }
    }
    else if (amount.compareTo(maximum64bit) < 0) {
        return write64(buffer, offset, amount);
    }
    else {
        return write72(buffer, offset, amount);
    }
}
exports.writeAmount = writeAmount;
function readAmount(buffer, offset) {
    var first = buffer.readUInt8(offset);
    offset++;
    var amount;
    var decimalShiftLeft = function (v, e) {
        return BigInteger.valueOf(v).multiply(BigInteger.valueOf(10).pow(BigInteger.valueOf(e)));
    };
    if ((first & 0x7E) === 0x7C || (first & 0x7C) === 0x78) {
        throw new Error("invalid amount");
    }
    else if ((first & 0x7E) === 0x7E) {
        if (first >= 0x80) {
            amount = BigInteger.fromBuffer(buffer.slice(offset, offset + 8));
            offset += 8;
        }
        else {
            amount = BigInteger.fromBuffer(buffer.slice(offset, offset + 7));
            offset += 7;
        }
    }
    else if (first < 0x80) {
        var second = buffer.readUInt8(offset);
        offset++;
        if ((first & 0x60) === 0x60) {
            var e = first & 0x1F;
            var s = second + 0x400;
            amount = decimalShiftLeft(s, e);
        }
        else {
            var e = (first & 0x7C) >> 2;
            var s = second + ((first & 0x03) << 8);
            amount = decimalShiftLeft(s, e);
        }
    }
    else {
        var second = buffer.readUInt8(offset);
        offset++;
        var lower = buffer.readUInt16BE(offset);
        offset += 2;
        if ((first & 0x40) === 0) {
            var e = (first & 0x3C) >> 2;
            var s = lower + (second << 16) + ((first & 0x03) << 24);
            amount = decimalShiftLeft(s, e);
        }
        else {
            var e = (first & 0x1E) >> 1;
            var s = lower + (second << 16) + ((first & 0x01) << 24) + 0x4000000;
            amount = decimalShiftLeft(s, e);
        }
    }
    return { amount: amount, offset: offset };
}
exports.readAmount = readAmount;
//# sourceMappingURL=Serialization.js.map